(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6207],{

/***/ 41796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ lighten; },
/* harmony export */   "_j": function() { return /* binding */ darken; }
/* harmony export */ });
/* unused harmony exports hexToRgb, decomposeColor, colorChannel, private_safeColorChannel, recomposeColor, rgbToHex, hslToRgb, getLuminance, getContrastRatio, alpha, private_safeAlpha, private_safeDarken, private_safeLighten, emphasize, private_safeEmphasize, blend */
/* harmony import */ var _mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56535);
/* harmony import */ var _mui_utils_clamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7610);

/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clampWrapper(value, min = 0, max = 1) {
  if (false) {}
  return (0,_mui_utils_clamp__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value, min, max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error( false ? 0 : (0,_mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
const colorChannel = color => {
  const decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const private_safeColorChannel = (color, warning) => {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  const {
    values
  } = decomposeColor(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha(color, value) {
  color = decomposeColor(color);
  value = clampWrapper(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha(color, value);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return emphasize(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */
function blend(background, overlay, opacity, gamma = 1.0) {
  const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
  const backgroundColor = decomposeColor(background);
  const overlayColor = decomposeColor(overlay);
  const rgb = [blendChannel(backgroundColor.values[0], overlayColor.values[0]), blendChannel(backgroundColor.values[1], overlayColor.values[1]), blendChannel(backgroundColor.values[2], overlayColor.values[2])];
  return recomposeColor({
    type: 'rgb',
    values: rgb
  });
}

/***/ }),

/***/ 95710:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/snapchat",
      function () {
        return __webpack_require__(30918);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69661);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41796);
/* harmony import */ var src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19550);
// ** React Imports


// ** MUI Imports


// ** Hooks Imports

const Avatar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    // ** Props
    const { sx , src , skin , color  } = props;
    // ** Hook
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const bgColors = (0,src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const getAvatarStyles = (skin, skinColor)=>{
        let avatarStyles;
        if (skin === "light") {
            avatarStyles = {
                ...bgColors["".concat(skinColor, "Light")]
            };
        } else if (skin === "light-static") {
            avatarStyles = {
                color: bgColors["".concat(skinColor, "Light")].color,
                backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* .lighten */ .$n)(theme.palette[skinColor].main, 0.88)
            };
        } else {
            avatarStyles = {
                ...bgColors["".concat(skinColor, "Filled")]
            };
        }
        return avatarStyles;
    };
    const colors = {
        primary: getAvatarStyles(skin, "primary"),
        secondary: getAvatarStyles(skin, "secondary"),
        success: getAvatarStyles(skin, "success"),
        error: getAvatarStyles(skin, "error"),
        warning: getAvatarStyles(skin, "warning"),
        info: getAvatarStyles(skin, "info")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        ref: ref,
        ...props,
        sx: !src && skin && color ? Object.assign(colors[color], sx) : sx
    });
});
Avatar.defaultProps = {
    skin: "filled",
    color: "primary"
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 19550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5026);
// ** MUI Imports

// ** Util Import

const UseBgColor = ()=>{
    // ** Hooks
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return {
        primaryFilled: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main
        },
        primaryLight: {
            color: theme.palette.primary.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.primary.main, 0.12)
        },
        secondaryFilled: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main
        },
        secondaryLight: {
            color: theme.palette.secondary.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.secondary.main, 0.12)
        },
        successFilled: {
            color: theme.palette.success.contrastText,
            backgroundColor: theme.palette.success.main
        },
        successLight: {
            color: theme.palette.success.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.success.main, 0.12)
        },
        errorFilled: {
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.main
        },
        errorLight: {
            color: theme.palette.error.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.error.main, 0.12)
        },
        warningFilled: {
            color: theme.palette.warning.contrastText,
            backgroundColor: theme.palette.warning.main
        },
        warningLight: {
            color: theme.palette.warning.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.warning.main, 0.12)
        },
        infoFilled: {
            color: theme.palette.info.contrastText,
            backgroundColor: theme.palette.info.main
        },
        infoLight: {
            color: theme.palette.info.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.info.main, 0.12)
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (UseBgColor);


/***/ }),

/***/ 5026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ hexToRGBA; }
/* harmony export */ });
/**
 ** Hex color to RGBA color
 */ const hexToRGBA = (hexCode, opacity)=>{
    let hex = hexCode.replace("#", "");
    if (hex.length === 3) {
        hex = "".concat(hex[0]).concat(hex[0]).concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]);
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
};


/***/ }),

/***/ 30918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_snapchat; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useDeviceScopedInit.js
var useDeviceScopedInit = __webpack_require__(82017);
// EXTERNAL MODULE: ./src/hooks/useExtremeUpgradeRefresh.js
var useExtremeUpgradeRefresh = __webpack_require__(57921);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/apps/snapchat/index.js
var snapchat = __webpack_require__(76351);
// EXTERNAL MODULE: ./src/@core/hooks/useSettings.js
var useSettings = __webpack_require__(51514);
// EXTERNAL MODULE: ./src/@core/utils/get-initials.js
var get_initials = __webpack_require__(83552);
// EXTERNAL MODULE: ./src/@core/utils/format.js
var format = __webpack_require__(59882);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 2 modules
var Badge = __webpack_require__(19529);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(97212);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(46483);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemAvatar/ListItemAvatar.js + 1 modules
var ListItemAvatar = __webpack_require__(18987);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/react-perfect-scrollbar/lib/index.js
var lib = __webpack_require__(51964);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
// EXTERNAL MODULE: ./src/components/NoData/index.js
var NoData = __webpack_require__(96665);
;// CONCATENATED MODULE: ./src/@core/components/snapchat/snapchat-side-bar.js
// ** React Imports


// ** Next Import

// ** MUI Imports













// ** Third Party Components

// ** Icon Imports




const ScrollWrapper = (param)=>{
    let { children , hidden  } = param;
    if (hidden) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                height: "100%",
                overflow: "auto"
            },
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            options: {
                wheelPropagation: false
            },
            children: children
        });
    }
};
const KikSideBar = (props)=>{
    // ** Props
    const { store , hidden , mdAbove , dispatch , userStatus , selectMessage , getInitials , sidebarWidth , setUserStatus , leftSidebarOpen , removeSelectedChat , userProfileLeftOpen , formatDateToMonthShort , handleLeftSidebarToggle , handleUserProfileLeftSidebarToggle , headImg , setHaedImg , chat , setChat , contacts , calls  } = props;
    // ** States
    const [query, setQuery] = (0,react.useState)("");
    const [filteredChat, setFilteredChat] = (0,react.useState)([]);
    const [filteredContacts, setFilteredContacts] = (0,react.useState)([]);
    const [active, setActive] = (0,react.useState)(null);
    // ** Hooks
    const router = (0,next_router.useRouter)();
    const handleChatClick = (type, id)=>{
        dispatch(selectMessage(id));
        setActive({
            type,
            id
        });
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const hasActiveId = (id)=>{
        if (store.chats !== null) {
            const arr = store.chats.filter((i)=>i.id === id);
            return !!arr.length;
        }
    };
    const ListHandler = (item)=>{
        setChat(true);
        setHaedImg(item.avatres);
    };
    const contactsHandler = ()=>{
        setChat(!chat);
    };
    const homeHandler = ()=>{
        setChat(true);
    };
    const renderChats = ()=>{
        if (store && store.list && store.list.length) {
            let data = [];
            if (query.length > 0 && filteredChat.length > 0) {
                data = filteredChat;
            } else {
                data = store.list;
            }
            return data.map((item, index)=>{
                let a = index + 1;
                if (a < 10) {
                    a = "0" + a;
                }
                let t = "2022-" + a + "-" + a;
                const lastMessage = {
                    time: t,
                    message: ""
                };
                const activeCondition = active !== null && active.id === item.id && active.type === "messages";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                    disablePadding: true,
                    sx: {
                        "&:not(:last-child)": {
                            mb: 1.5
                        }
                    },
                    onClick: ()=>ListHandler(item),
                    className: "border-b-[1px] border-[#E5E7EB] border-opacity-40",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                        onClick: ()=>handleChatClick("messages", item.id),
                        sx: {
                            px: 1.5,
                            py: 1.5,
                            width: "100%",
                            borderRadius: 1,
                            alignItems: "flex-start",
                            ...activeCondition && {
                                backgroundColor: (theme)=>"#E5E7EB"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                                sx: {
                                    m: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                    overlap: "circular",
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "right"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: item.avatres,
                                        sx: {
                                            width: 38,
                                            height: 38,
                                            outline: (theme)=>"1px solid ".concat(activeCondition ? theme.palette.common.white : "transparent")
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                sx: {
                                    my: 0,
                                    ml: 4,
                                    mr: 1.5
                                },
                                primary: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                ...!activeCondition ? {
                                                    color: "text.secondary"
                                                } : {},
                                                fontWeight: 600,
                                                fontSize: 13
                                            },
                                            children: item.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "overflow-clip",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "w-5/6 h-[20px] text-[12px] overflow-ellipsis font-semibold text-[#292A2C] text-opacity-60",
                                                children: item.chat
                                            })
                                        })
                                    ]
                                }),
                                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    noWrap: true,
                                    variant: "body2",
                                    sx: {
                                        ...!activeCondition && {
                                            color: "text.disabled"
                                        }
                                    },
                                    children: lastMessage ? lastMessage.message : null
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "flex-end",
                                    flexDirection: "column",
                                    justifyContent: "flex-start"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        whiteSpace: "nowrap",
                                        color: activeCondition ? "common.white" : "text.disabled",
                                        fontSize: "0.8rem",
                                        fontWeight: 500
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-black text-opacity-60 text-[12px]",
                                        children: item.time
                                    })
                                })
                            })
                        ]
                    })
                }, index);
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                        color: "text.secondary"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoData/* default */.Z, {})
                })
            });
        }
    };
    const handleFilter = (e)=>{
        setQuery(e.target.value);
        if (store.list !== null && store.list.length > 0) {
            const filteredChatsArr = store.list.filter((item)=>{
                return item.name.indexOf(e.target.value) >= 0;
            });
            setFilteredChat(filteredChatsArr);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
            open: leftSidebarOpen,
            onClose: handleLeftSidebarToggle,
            variant: mdAbove ? "permanent" : "temporary",
            ModalProps: {
                disablePortal: true,
                keepMounted: true // Better open performance on mobile.
            },
            sx: {
                zIndex: 7,
                height: "100%",
                display: "block",
                position: mdAbove ? "static" : "absolute",
                "& .MuiDrawer-paper": {
                    boxShadow: "none",
                    overflow: "hidden",
                    width: sidebarWidth,
                    position: mdAbove ? "static" : "absolute",
                    borderTopLeftRadius: (theme)=>theme.shape.borderRadius,
                    borderBottomLeftRadius: (theme)=>theme.shape.borderRadius
                },
                "& > .MuiBackdrop-root": {
                    borderRadius: 1,
                    position: "absolute",
                    zIndex: (theme)=>theme.zIndex.drawer - 1
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    height: "calc(100% - 4.125rem)",
                    backgroundColor: "#"
                },
                className: "border-r-[1px] border-black border-opacity-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
                    hidden: hidden,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            p: (theme)=>theme.spacing(2, 3, 3)
                        },
                        children: [
                            !mdAbove ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                sx: {
                                    p: 1,
                                    ml: 1,
                                    mt: 4
                                },
                                onClick: handleLeftSidebarToggle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    icon: "mdi:close",
                                    fontSize: "1.375rem"
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                sx: {
                                    mb: 7.5,
                                    p: 0,
                                    mt: 4
                                },
                                className: "",
                                children: renderChats()
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var snapchat_side_bar = (KikSideBar);

// EXTERNAL MODULE: ./src/@core/components/mui/avatar/index.js
var avatar = __webpack_require__(92024);
;// CONCATENATED MODULE: ./src/@core/components/snapchat/snapchat-log.js
// ** React Imports


// ** MUI Imports



// ** Third Party Components



const PerfectScrollbar = (0,styled/* default */.ZP)((lib_default()))((param)=>{
    let { theme  } = param;
    return {
        padding: theme.spacing(5)
    };
});
const MessagesLog = (props)=>{
    // ** Props
    const { data , hidden  } = props;
    // ** Ref
    const chatArea = (0,react.useRef)(null);
    // ** Scroll to chat bottom
    const scrollToBottom = ()=>{
        if (chatArea.current) {
            if (hidden) {
                // @ts-ignore
                chatArea.current.scrollTop = Number.MAX_SAFE_INTEGER;
            } else {
                // @ts-ignore
                chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER;
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (data && data.chat && data.chat.length) {
            scrollToBottom();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data
    ]);
    // ** Renders user chat
    const renderChats = ()=>{
        return data.chat.chat.map((item, index)=>{
            const isSender = item.isFromMe;
            const time = new Date(item.date).toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: !item.isFromMe ? "row" : "row-reverse"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.Z, {
                            skin: "light",
                            sx: {
                                width: "2rem",
                                height: "2rem",
                                fontSize: "0.875rem",
                                ml: isSender ? 4 : undefined,
                                mr: !isSender ? 4 : undefined
                            },
                            ...data.chat.contact.avatar && !isSender ? {
                                src: data.chat.contact.avatar
                            } : {},
                            ...isSender ? {
                                src: "/images/avatars/1.png"
                            } : {}
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: "chat-body",
                        sx: {
                            maxWidth: [
                                "calc(100% - 5.75rem)",
                                "75%",
                                "65%"
                            ],
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                "&:not(:last-of-type)": {
                                    mb: 3.5
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        boxShadow: 1,
                                        borderRadius: 1,
                                        width: "fit-content",
                                        p: (theme)=>theme.spacing(0, 2),
                                        ml: isSender ? "auto" : undefined,
                                        borderTopLeftRadius: !isSender ? 0 : undefined,
                                        borderTopRightRadius: isSender ? 0 : undefined,
                                        color: isSender ? "black" : "text.primary",
                                        backgroundColor: isSender ? "#D1FAE5" : "#F3F4F6",
                                        mb: 4.4,
                                        mt: 2
                                    },
                                    children: typeof item.img === "undefined" || item.img === "" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: " flex p-2 ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-semibold text-[0.7rem] text-black text-opacity-80 ",
                                                    children: item.text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute bottom-0 right-0 ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    variant: "caption",
                                                    sx: {
                                                        color: "text.disabled"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: " text-[#9CA3AF] text-[0.6rem] ",
                                                        children: time
                                                    })
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.img,
                                        alt: "Picture of the author",
                                        width: 150,
                                        height: 150
                                    })
                                })
                            })
                        }, index)
                    })
                ]
            }, index);
        });
    };
    const ScrollWrapper = (param)=>{
        let { children  } = param;
        if (hidden) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                ref: chatArea,
                sx: {
                    p: 5,
                    height: "100%",
                    overflowY: "auto",
                    overflowX: "hidden"
                },
                children: children
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PerfectScrollbar, {
                ref: chatArea,
                options: {
                    wheelPropagation: false
                },
                children: children
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            height: "calc(100% - 8.4375rem)"
        },
        className: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
            children: renderChats()
        })
    });
};
/* harmony default export */ var snapchat_log = (MessagesLog);

;// CONCATENATED MODULE: ./src/@core/components/snapchat/snapchat-content.js





// ** Icon Imports

// ** Custom Components Import



// ** Styled Components
const ChatWrapperStartChat = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        flexGrow: 1,
        height: "100%",
        display: "flex",
        borderRadius: 1,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: theme.palette.action.hover
    };
});
const KikContent = (props)=>{
    // ** Props
    const { data , store , hidden , sendMsg , mdAbove , dispatch , getInitials , sidebarWidth , userProfileRightOpen , handleLeftSidebarToggle , handleUserProfileRightSidebarToggle , headImg  } = props;
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const handleStartConversation = ()=>{
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const renderContent = ()=>{
        if (store) {
            const selectedMessage = store.selectedMessage;
            if (!selectedMessage) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatWrapperStartChat, {
                    sx: {
                        ...mdAbove ? {
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0
                        } : {}
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        onClick: handleStartConversation,
                        sx: {
                            px: 6,
                            py: 2.25,
                            boxShadow: 3,
                            borderRadius: 5,
                            backgroundColor: "background.paper",
                            cursor: mdAbove ? "default" : "pointer"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontWeight: 600
                            },
                            children: t("Start Conversation")
                        })
                    })
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        flexGrow: 1,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "white"
                    },
                    children: selectedMessage && store.userProfile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snapchat_log, {
                        hidden: hidden,
                        data: {
                            ...selectedMessage
                        }
                    }) : null
                });
            }
        } else {
            return null;
        }
    };
    return renderContent();
};
/* harmony default export */ var snapchat_content = (KikContent);

;// CONCATENATED MODULE: ./src/@core/components/snapchat/snapchat-contacts.js





// ** Icon Imports



// ** Styled Components
const snapchat_contacts_ChatWrapperStartChat = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        flexGrow: 1,
        height: "100%",
        display: "flex",
        borderRadius: 1,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: theme.palette.action.hover
    };
});
const KikContacts = (props)=>{
    // ** Props
    const { data , store , hidden , sendMsg , mdAbove , dispatch , getInitials , sidebarWidth , callData , userProfileRightOpen , handleLeftSidebarToggle , handleUserProfileRightSidebarToggle , setContacts  } = props;
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const handleStartConversation = ()=>{
        if (!mdAbove) {
            handleLeftSidebarToggle();
        }
    };
    const renderContent = ()=>{
        if (store) {
            const selectedMessage = store.selectedMessage;
            if (!selectedMessage) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snapchat_contacts_ChatWrapperStartChat, {
                    sx: {
                        ...mdAbove ? {
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0
                        } : {}
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        onClick: handleStartConversation,
                        sx: {
                            px: 6,
                            py: 2.25,
                            boxShadow: 3,
                            borderRadius: 5,
                            backgroundColor: "background.paper",
                            cursor: mdAbove ? "default" : "pointer"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontWeight: 600
                            },
                            children: t("Start Conversation")
                        })
                    })
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            flexGrow: 1,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    py: 3,
                                    px: 5,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider),
                                    backgroundColor: "#",
                                    height: 60
                                },
                                className: "border-b-[1px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        mdAbove ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            onClick: handleLeftSidebarToggle,
                                            sx: {
                                                mr: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                icon: "mdi:menu"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            onClick: handleUserProfileRightSidebarToggle,
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    flexDirection: "column"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    sx: {
                                                        color: "black",
                                                        fontWeight: 700
                                                    },
                                                    children: "Contacts"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "overflow-auto h-[90%] ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-4 gap-y-4 w-11/12 mx-auto mt-8 sm:grid-cols-2",
                                    children: callData.contacts.map((item)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "bg-white rounded-lg h-[150px] w-5/6 items-center grid shadow-2xl",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex items-center justify-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: item.img,
                                                        alt: "img",
                                                        width: 55,
                                                        height: 55,
                                                        className: " rounded-full"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex items-center justify-center text-[14px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "font-bold",
                                                        children: item.name
                                                    })
                                                })
                                            ]
                                        }, item.id);
                                    })
                                })
                            })
                        ]
                    })
                });
            }
        } else {
            return null;
        }
    };
    return renderContent();
};
/* harmony default export */ var snapchat_contacts = (KikContacts);

// EXTERNAL MODULE: ./src/@core/components/common/chatCall.js
var chatCall = __webpack_require__(55574);
// EXTERNAL MODULE: ./src/@api/dashboard.js
var dashboard = __webpack_require__(95629);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(33185);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
;// CONCATENATED MODULE: ./src/pages/snapchat/index.js
// ** React Imports




// ** MUI Imports





// ** Store & Actions Imports


// ** Hooks

// ** Utils Imports











// ** Icon Imports

// ** Chat App Components Imports




const snapchat_PerfectScrollbar = (0,styled/* default */.ZP)((lib_default()))((param)=>{
    let { theme  } = param;
    return {
        padding: theme.spacing(5)
    };
});
// component







const Snapchat = ()=>{
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    // ** States
    const [userStatus, setUserStatus] = (0,react.useState)("online");
    const [leftSidebarOpen, setLeftSidebarOpen] = (0,react.useState)(false);
    const [userProfileLeftOpen, setUserProfileLeftOpen] = (0,react.useState)(false);
    const [userProfileRightOpen, setUserProfileRightOpen] = (0,react.useState)(false);
    const [advanced, setAdvanced] = (0,react.useState)(true) // 是否购买高级服务
    ;
    const [fetchLoading, setFetchLoading] = (0,react.useState)(true) // 数据获取中
    ;
    // ** Hooks
    const theme = (0,useTheme/* default */.Z)();
    const { settings  } = (0,useSettings/* useSettings */.r)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const hidden = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const store = (0,es/* useSelector */.v9)((state)=>state.Snapchat);
    // ** Vars
    const { skin  } = settings;
    const smAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const sidebarWidth = smAbove ? 370 : 300;
    const mdAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    const [chat, setChat] = (0,react.useState)(true);
    const [headImg, setHaedImg] = (0,react.useState)("/images/snapchat/1.jpg");
    (0,react.useEffect)(()=>{
        dispatch((0,snapchat/* fetchUserProfile */.YI)());
        dispatch((0,snapchat/* fetchChatsContacts */.Pu)());
    }, [
        dispatch
    ]);
    const handleLeftSidebarToggle = ()=>setLeftSidebarOpen((prev)=>!prev);
    const handleUserProfileLeftSidebarToggle = ()=>setUserProfileLeftOpen((prev)=>!prev);
    const handleUserProfileRightSidebarToggle = ()=>setUserProfileRightOpen((prev)=>!prev);
    const [switchDataType, setSwitchDataType] = (0,react.useState)("activity");
    let selectSwitchDataStyle = {
        background: "#121444",
        color: "#fff",
        display: "inline-block",
        width: "90px",
        height: "26px",
        lineHeight: "26px",
        fontSize: "18px",
        textAlign: "center"
    };
    let switchDataStyle = {
        display: "inline-block",
        width: "90px",
        height: "26px",
        lineHeight: "26px",
        fontSize: "18px",
        textAlign: "center"
    };
    let [chatCallData, setChatCallData] = (0,react.useState)([]);
    const [currentPage, setCurrentPage] = (0,react.useState)(1);
    const [total, setTotal] = (0,react.useState)(0);
    // 分页参数
    const [pagination, setPagination] = (0,react.useState)({
        reqNum: 50,
        nowOffset: 0,
        maxNum: false // 全部数据查询完毕
    });
    const getChatCallData = async (nowOffset)=>{
        const username = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        // 获取最近的10笔订单
        let res = await (0,login.getUserAccountOrder)({
            page: 1,
            pageSize: 10
        });
        // 查找有限期最长的订单
        const lastOrder = res.data.sort((a, b)=>dayjs_min_default()(b.expire_time).valueOf() - dayjs_min_default()(a.expire_time).valueOf())[0];
        // 计算是否为增值服务上线前付费用户
        // 增值服务上线前付费用户状态更新
        let data = await (0,dashboard/* getAllDashboard */.gP)({
            username,
            params: {
                category: "SNAPCHAT_INTERACTION",
                offset: nowOffset,
                limit: pagination.reqNum,
                deviceUdid: JSON.parse(localStorage.getItem("currentDevice")) != null ? JSON.parse(localStorage.getItem("currentDevice"))["Unique Identifier"] : ""
            }
        });
        setTotal(data.data.totalCount);
        const advanced = username == null || !("advanced" in data) || [
            "true",
            true
        ].includes(data === null || data === void 0 ? void 0 : data.advanced) // 高级服务开通状态
        ;
        setAdvanced(advanced);
        dispatch((0,Common/* changeExtremeService */.xU)(advanced)) // 更新高级服务状态
        ;
        if (data.data.contents == null) {
            setPagination((page)=>({
                    ...page,
                    maxNum: true
                }));
            setFetchLoading(false);
            return;
        }
        let result = data.data.contents.map((row)=>{
            return {
                ...row,
                date: dayjs_min_default()(row.date).format("YYYY-MM-DD HH:mm:ss"),
                icon: "prime:send",
                color: row.isFromMe ? "#585858" : "#D43538"
            };
        });
        if (!advanced) result = (0,utils/* generateMockData */.W)(result);
        setChatCallData((old)=>[
                ...old,
                ...result
            ]);
        setFetchLoading(false);
    };
    // 设备切换时重置列表并重新拉数
    (0,useDeviceScopedInit/* useDeviceScopedInit */.A)((0,react.useCallback)(()=>{
        setChatCallData([]);
        setPagination({
            reqNum: 50,
            nowOffset: 0,
            maxNum: false
        });
        setScroll(0);
        setCurrentPage(1);
        setTotal(0);
        setFetchLoading(true);
        getChatCallData(0);
    }, []));
    // 升级成功后重拉本页数据（监听 extreme-upgraded，逻辑对齐 useDeviceScopedInit）
    (0,useExtremeUpgradeRefresh/* useExtremeUpgradeRefresh */.v)((0,react.useCallback)(()=>{
        setAdvanced(true);
        setChatCallData([]);
        setPagination({
            reqNum: 50,
            nowOffset: 0,
            maxNum: false
        });
        setScroll(0);
        setCurrentPage(1);
        setTotal(0);
        setFetchLoading(true);
        getChatCallData(0);
    }, []));
    const dom = (0,react.useRef)(null);
    // 滚动百分比
    const [scroll, setScroll] = (0,react.useState)(0);
    // 获取滚动百分比
    (0,react.useEffect)(()=>{
        const handScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = dom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    (0,react.useEffect)(()=>{
        if (scroll >= 100 && advanced) {
            const nowOffset = pagination.nowOffset + pagination.reqNum;
            setPagination((page)=>({
                    ...page,
                    nowOffset
                }));
            if (!pagination.maxNum) getChatCallData(nowOffset);
        }
    }, [
        scroll
    ]);
    (0,react.useEffect)(()=>{
        const title = t("Snapchat");
        dispatch((0,Common/* setCurrentTab */.Lw)(title));
        return ()=>dispatch((0,Common/* setCurrentTab */.Lw)(""));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            switchDataType == "activity" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chatCall/* default */.Z, {
                    dom: dom,
                    data: chatCallData,
                    advanced: advanced,
                    fetchLoading: fetchLoading
                })
            }) : null,
            switchDataType == "chat" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: "app-chat",
                    sx: {
                        width: "92%",
                        minHeight: "calc(var(--vh)*100 - 370px)",
                        display: "flex",
                        borderRadius: 1,
                        position: "relative",
                        boxShadow: skin === "bordered" ? 0 : 6,
                        ...skin === "bordered" && {
                            border: "1px solid ".concat(theme.palette.divider)
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snapchat_side_bar, {
                            store: store,
                            hidden: hidden,
                            mdAbove: mdAbove,
                            dispatch: dispatch,
                            userStatus: userStatus,
                            selectMessage: snapchat/* selectMessage */.rT,
                            getInitials: get_initials/* getInitials */.Q,
                            sidebarWidth: sidebarWidth,
                            setUserStatus: setUserStatus,
                            leftSidebarOpen: leftSidebarOpen,
                            removeSelectedChat: snapchat/* removeSelectedChat */.sr,
                            userProfileLeftOpen: userProfileLeftOpen,
                            formatDateToMonthShort: format/* formatDateToMonthShort */.oS,
                            handleLeftSidebarToggle: handleLeftSidebarToggle,
                            handleUserProfileLeftSidebarToggle: handleUserProfileLeftSidebarToggle,
                            headImg: headImg,
                            setChat: setChat,
                            chat: chat,
                            setHaedImg: setHaedImg
                        }),
                        chat && /*#__PURE__*/ (0,jsx_runtime.jsx)(snapchat_content, {
                            store: store,
                            hidden: hidden,
                            mdAbove: mdAbove,
                            dispatch: dispatch,
                            getInitials: get_initials/* getInitials */.Q,
                            sidebarWidth: sidebarWidth,
                            userProfileRightOpen: userProfileRightOpen,
                            handleLeftSidebarToggle: handleLeftSidebarToggle,
                            handleUserProfileRightSidebarToggle: handleUserProfileRightSidebarToggle,
                            headImg: headImg,
                            setHaedImg: setHaedImg
                        }),
                        chat === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snapchat_contacts, {
                            store: store,
                            hidden: hidden,
                            mdAbove: mdAbove,
                            dispatch: dispatch,
                            getInitials: get_initials/* getInitials */.Q,
                            sidebarWidth: sidebarWidth,
                            userProfileRightOpen: userProfileRightOpen,
                            handleLeftSidebarToggle: handleLeftSidebarToggle,
                            handleUserProfileRightSidebarToggle: handleUserProfileRightSidebarToggle,
                            headImg: headImg,
                            setHaedImg: setHaedImg
                        }) : ""
                    ]
                })
            }) : null
        ]
    });
};
Snapchat.contentHeightFixed = true;
/* harmony default export */ var pages_snapchat = (Snapchat);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,518,2862,770,2607,6664,210,8863,1964,6853,7891,1558,2159,5983,3769,6719,9774,2888,179], function() { return __webpack_exec__(95710); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);